var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInitiateOfferRelease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.125,
    height: 11.374,
    viewBox: "0 0 8.125 11.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1632",
    "data-name": "Group 1632",
    transform: "translate(-1627.939 -367.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-blank",
    transform: "translate(1591.939 355.315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M44,14.963,41.159,12.12A.369.369,0,0,0,40.875,12H36.812A.815.815,0,0,0,36,12.81V22.56a.815.815,0,0,0,.812.812h6.5a.815.815,0,0,0,.812-.812V15.248A.369.369,0,0,0,44,14.963Zm-3.128-1.99,2.275,2.275H40.875Zm2.437,9.587h-6.5V12.81h3.25v2.437a.815.815,0,0,0,.812.812h2.437Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M104.383,60H102v.681h2.383Z",
    transform: "translate(1527.973 311.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M98.723,90H96v.681h2.723Z",
    transform: "translate(1533.973 283.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M93.064,120H90v.681h3.064Z",
    transform: "translate(1539.973 255.362)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiateOfferRelease);
export default __webpack_public_path__ + "static/media/Initiate Offer Release .e2afb254913815e06480f119805f594b.svg";
export { ForwardRef as ReactComponent };